import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  showSideDrawer: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.NAV_TOGGLE: {
      return {
        ...state,
        showSideDrawer: !state.showSideDrawer,
      };
    }

    default:
      return state;
  }
};

export default reducer;
